import { Logger, type FeatureValue } from '@terros/common'
import { useMemo } from 'react'
import z from 'zod'
import { useFeatureConfig } from './config'

const AnnouncementSchema = z.object({
  message: z.string().optional(),
  actions: z.array(z.object({ label: z.string(), url: z.string() })).optional(),
})
export type HomeScreenAnnouncement = z.infer<typeof AnnouncementSchema>

const homeScreenAnnouncementLogger = new Logger('Feature:EnhancedHomeScreenAnnouncement')

export const useHomeScreenAnnouncement = (): HomeScreenAnnouncement => {
  const { data: featureConfig } = useFeatureConfig({
    featureId: 'Feature:EnhancedHomeScreenAnnouncement',
    fallback: '{}',
  })
  return useMemo(() => parseAnnouncement(featureConfig?.value, homeScreenAnnouncementLogger) ?? {}, [featureConfig])
}

function parseAnnouncement(value: FeatureValue | undefined, logger: Logger): HomeScreenAnnouncement | undefined {
  try {
    if (typeof value !== 'string') return
    const parsed = AnnouncementSchema.safeParse(JSON.parse(value))
    if (!parsed.success) return undefined
    return parsed.data
  } catch (e) {
    logger.error('Failed to parse announcement', e)
    return undefined
  }
}
